export default function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-redux/~/@babel/runtime/helpers/esm/setPrototypeOf.js
// module id = 1041
// module chunks = 30 31 32